// extracted by mini-css-extract-plugin
export var address = "Locations-module--address--NFSK1";
export var bulletPoint = "Locations-module--bulletPoint--Qgb0I";
export var country = "Locations-module--country--cEmTM";
export var label = "Locations-module--label--kdSyq";
export var office = "Locations-module--office--V0cwz";
export var offices = "Locations-module--offices--7geEF";
export var wrapper = "Locations-module--wrapper--qFtc9";